/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPalletOrderLookupItem
 */
export interface AdminPalletOrderLookupItem {
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderLookupItem
     */
    asin: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderLookupItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPalletOrderLookupItem
     */
    price: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPalletOrderLookupItem
     */
    quantity: number;
}

export function AdminPalletOrderLookupItemFromJSON(json: any): AdminPalletOrderLookupItem {
    return AdminPalletOrderLookupItemFromJSONTyped(json, false);
}

export function AdminPalletOrderLookupItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPalletOrderLookupItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asin': json['asin'],
        'name': json['name'],
        'price': json['price'],
        'quantity': json['quantity'],
    };
}

export function AdminPalletOrderLookupItemToJSON(value?: AdminPalletOrderLookupItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asin': value.asin,
        'name': value.name,
        'price': value.price,
        'quantity': value.quantity,
    };
}

